import { System } from '@ecs/System';
import { CameraShake } from '@components/CameraShake';

export class CameraShakeSystem extends System {
  update(_deltaTime: number): void {
    for (const entity of this.getEntitiesWithComponents(CameraShake)) {
      const shake = entity.getComponent(CameraShake)!;
      shake.trauma = Math.max(0, shake.trauma - shake.decayPerFrame);
    }
  }
}
